import { toDecimal } from "../helpers/PriceShopEngine";

export interface ManagementCompoundComponent {
  id: string;
  compound_id: string;
  product_reference: string;
  component_type_key: ManagementComponentTypeKey;
  component_name: string;
  category_reference: string;
  category_name: string;
  product_name: string;
  product_description: string;
  product_image: string;
  product_brand: string;
  quantity: number;
  configured_available_quantity: number;
  erp_available_quantity: number;
  erp_synced_at?: string | null;
  optional: boolean;
  base_component: boolean;
  configured_compound_reseller_price: number;
  configured_discount_rate: number;
  configured_discount_value: number;
  configured_override_price: number | null;
  configured_reseller_price: number;
  configured_cost_price: number;
  erp_compound_reseller_price: number;
  erp_discount_rate: number;
  erp_discount_value: number;
  erp_override_price: number | null;
  erp_reseller_price: number;
  erp_cost_price: number;
  vat_rate: number;
  version: number;
  status: "DRAFT" | "PENDING" | "PUBLISHED" | "HIDDEN" | "ARCHIVED";
  getCostPrice(type?: "configured" | "erp"): number;
  getRev4Price(type?: "configured" | "erp"): number;
  getResellerPrice(type?: "configured" | "erp"): number;
  getDiscountValue(type?: "configured" | "erp"): number;
  getDiscountRate(type?: "configured" | "erp"): number;
  getOverridePrice(type?: "configured" | "erp"): number | null;
  getAvailableQuantity(type?: "configured" | "erp"): number;

  checkPriceDifference(): number;
}

export function NewManagementCompoundComponent(
  data: ManagementCompoundComponent,
): ManagementCompoundComponent {
  return {
    ...data,

    getCostPrice(type: "configured" | "erp" = "configured"): number {
      if (type === "configured") {
        return this.configured_cost_price;
      }
      return this.erp_cost_price;
    },

    getRev4Price(type: "configured" | "erp" = "configured"): number {
      if (type === "configured") {
        return this.configured_compound_reseller_price;
      }
      return this.erp_compound_reseller_price;
    },

    getResellerPrice(type: "configured" | "erp" = "configured"): number {
      if (type === "configured") {
        return this.configured_reseller_price;
      }
      return this.erp_reseller_price;
    },

    getDiscountValue(type: "configured" | "erp" = "configured"): number {
      if (type === "configured") {
        return this.configured_discount_value;
      }
      return this.erp_discount_value;
    },

    getDiscountRate(type: "configured" | "erp" = "configured"): number {
      if (type === "configured") {
        return this.configured_discount_rate;
      }
      return this.erp_discount_rate;
    },

    getOverridePrice(type: "configured" | "erp" = "configured"): number | null {
      if (type === "configured") {
        return this.configured_override_price;
      }
      return this.erp_override_price;
    },

    getAvailableQuantity(type: "configured" | "erp" = "configured"): number {
      if (type === "configured") {
        return this.configured_available_quantity;
      }
      return this.erp_available_quantity;
    },

    checkPriceDifference(): number {
      const diff =
        toDecimal(this.getResellerPrice("erp")) -
        toDecimal(this.getResellerPrice("configured"));
      if (diff > 0.1 || diff < -0.1) {
        console.log(
          `Price difference for component ${this.component_name} (ID: ${this.id}): ERP Price = ${this.getResellerPrice("erp")}, Configured Price = ${this.getResellerPrice("configured")}, Difference = ${diff}`,
        );
        return diff;
      }
      const diffCost =
        toDecimal(this.getCostPrice("erp")) -
        toDecimal(this.getCostPrice("configured"));
      if (diff > 0.1 || diff < -0.1) {
        console.log(
          `Cost price difference for component ${this.component_name} (ID: ${this.id}): ERP Cost Price = ${this.getCostPrice("erp")}, Configured Cost Price = ${this.getCostPrice("configured")}, Difference = ${diffCost}`,
        );
        return diffCost;
      }
      return 0;
    },
  };
}
